import {
  GroupItemKinds,
  GroupKind,
  LinkKind,
} from '@care/navigation/dist/components/GlobalNavIA/NavLinkList/NavLinkList';
import { CareCategory } from '@care/navigation';
import { createMoreInfoColumn } from './createMoreInfoColumn';

export const keyToCareCategoryMap: Record<string, CareCategory> = Object.freeze({
  childCareLinks: CareCategory.ChildCare,
  seniorCareLinks: CareCategory.SeniorCare,
  adultCareLinks: CareCategory.AdultCare,
  petCareLinks: CareCategory.PetCare,
  housekeepingLinks: CareCategory.Housekeeping,
  tutoringLinks: CareCategory.Tutoring,
});

export const buildFindCareVerticalSection = (
  baseURL: string,
  key: string,
  vgnLinkList: LinkKind[],
  isLargeViewport: boolean,
  moreInfoCommonLinks: GroupItemKinds[]
): GroupKind[] => {
  const verticalSection: GroupKind[] = [
    {
      id: `${keyToCareCategoryMap[key]}-vertical`,
      kind: 'group',
      items: vgnLinkList,
    },
  ];

  // Create and add a "More info" column to the vertical section for large viewports.
  if (isLargeViewport) {
    verticalSection.push(createMoreInfoColumn(baseURL, key, moreInfoCommonLinks));
  }

  return verticalSection;
};
